import { UserRoleEnum } from "@/types/user"

export const roleImportanceByOrder = [
  UserRoleEnum.SysAdmin,
  UserRoleEnum.Support,
  UserRoleEnum.Admin,
  UserRoleEnum.User,
  UserRoleEnum.ServiceUser
]
